import React from "react";
import styled from "styled-components";

const ButtonStyled = styled.button`
  background-color: ${(props) => props.theme.colors.primary};
  border-radius: 56px;
  display: flex;
  outline: none;
  border: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 19px 32px;
  gap: 8px;
  color: #fff;

  &:hover {
    background-color: ${(props) => props.theme.colors.light};
    color: #000;
    transition: cubic-bezier(0.215, 0.61, 0.355, 1) 0.3s all;
    cursor: pointer;
  }

  &:disabled {
    background-color: ${(props) => props.theme.colors.light};
    color: #000;
    transition: cubic-bezier(0.215, 0.61, 0.355, 1) 0.3s all;
    cursor: not-allowed;
  }
`;

const ButtonText = styled.span`
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  color: inherit;
`;

const Button: React.FC<Props> = ({ children, onClick, type, disabled }) => {
  return (
    <ButtonStyled onClick={onClick} type={type} disabled={disabled}>
      <ButtonText>{children}</ButtonText>
    </ButtonStyled>
  );
};

export default Button;

interface Props {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit";
  disabled?: boolean;
}
